import { useDebugValue, useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hooks to get query parameters.
 * @returns {URLSearchParams} - The current location URLSearchParams
 */
const useQuery = () => {
    const { search } = useLocation();
    const retval = useMemo(() => Object.fromEntries([...(new URLSearchParams(search).entries())].map(([key, value]) => [key, value.replace(/ /g, "+")])), [search]);
    useDebugValue(retval);
    return retval;
};

export default useQuery;